/**
 * Determines appropriate link properties for phone numbers and addresses.
 */
export const getLinkProps = (icon: string, html: string) => {
  if (icon === 'phone') {
    const trimmed = html.trim();
    if (/^\+?\d+$/.test(trimmed)) {
      return { href: `tel:${trimmed}` };
    }
  }

  // Address detection and Google Maps link generation
  if (icon === 'location-dot') {
    const trimmed = html.trim();
    // Recognize a trailing 3-letter uppercase code (state/country)
    if (/\b[A-Z]{3}$/.test(trimmed)) {
      return {
        href: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
          trimmed,
        )}`,
        target: '_blank',
        rel: 'noopener noreferrer',
      };
    }
  }

  return null;
};
